import { QueryClient } from "@tanstack/react-query";
/** Shared client so auth can clear cached data on logout or account change. */
export const queryClient = new QueryClient();
